import { getCounterLabel, UnitType } from '../utils/allocation'

interface AllocationCountersProps {
  total: number
  remaining: number
  unitType: UnitType
}

const AllocationCounters = ({
  total,
  remaining,
  unitType,
}: AllocationCountersProps) => {
  const totalLabel = getCounterLabel('total', total, unitType)
  const remainingLabel = getCounterLabel('remaining', remaining, unitType)

  const isFullyAllocated = remaining === 0

  return (
    <div className="flex items-center justify-between">
      <div
        aria-atomic="true"
        aria-live="polite"
        className="text-lg font-medium text-gray-700"
        role="status"
      >
        {totalLabel}
      </div>

      <div
        aria-atomic="true"
        aria-live="polite"
        className={`text-lg font-medium transition-colors ${
          isFullyAllocated ? 'text-gray-700' : 'font-semibold text-error-700'
        }`}
        role="status"
      >
        {remainingLabel}
      </div>
    </div>
  )
}

export default AllocationCounters
